/**
 * Styled container for the top row of description sections.
 * Provides flex layout for aligning description elements horizontally.
 */

import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

/**
 * Flex container for description top row elements with responsive spacing.
 */
const DescriptionTopRowContainer = styled.div.attrs({
  id: 'descriptionTopRowContainer',
})<React.CSSProperties>`
  display: flex;
  align-items: end;
  gap: ${10 * Screen.widthRatio}px;
`;

export default DescriptionTopRowContainer;
